import { render } from "./ups.vue?vue&type=template&id=1fd196c2&scoped=true"
import script from "./ups.vue?vue&type=script&lang=js"
export * from "./ups.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd196c2"]])

export default __exports__